import IssueDetail from '@/components/linear/issue-detail';
import { useWorkspaceChrome } from '@/components/linear/workspace-chrome';
import { isTypingTarget } from '@/lib/linear-utils';
import { useEffect } from 'react';

export default function PeekOverlay() {
  const { peekIssue, setPeekIssue } = useWorkspaceChrome();

  useEffect(() => {
    if (!peekIssue) return;
    const onKey = (event: KeyboardEvent) => {
      if (isTypingTarget(event.target)) return;
      if (event.key === 'Escape' || event.key === ' ') {
        event.preventDefault();
        setPeekIssue(null);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [peekIssue, setPeekIssue]);

  if (!peekIssue) return null;

  return (
    <div
      className="ln-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Issue peek"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) setPeekIssue(null);
      }}
    >
      <div className="ln-peek-card">
        <IssueDetail key={peekIssue.id} issue={peekIssue} onClose={() => setPeekIssue(null)} />
      </div>
    </div>
  );
}
